import * as React from "react";
import DeviceContext from "./../../../service/indentifyDevice";
import OpLayout from "../opLayout/opLayout";
import { AGetQuotesNfo, AGetQuotesExtraNfo } from "./../../../service/orderPlacement/opApiService";
import OpQuotesNfoDsk from "../opQuotes/opQuotesNfo/opQuotesNfoDsk";
import OpQuotesNfoMob from "../opQuotes/opQuotesNfo/opQuotesNfoMob";
import OpQuotesNfoTab from "../opQuotes/opQuotesNfo/opQuotesNfoTab";

export interface IOpNfoContainerProps {}

export interface IOpNfoContainerState {
	quoteData: any;
	quoteDataExtra: any;
}

class OpNfoContainer extends React.Component<IOpNfoContainerProps, IOpNfoContainerState> {
	state: IOpNfoContainerState = { quoteData: {}, quoteDataExtra: {} };
	quoteComp: any;
	isin = "INF200KA1Q24";

	getQuoteExtraNfoRes = (res: any) => {
		this.setState({quoteDataExtra: res.nfoStaticData})
	}

	getSchemeDetailsRes = (res: any) => {
		this.setState({ quoteData: res });

		// find scode
		const scode = res.schemeISIN.find((a: any) => a.ISIN === this.isin).Token;

		AGetQuotesExtraNfo(this.getQuoteExtraNfoRes, scode);
	};

	componentDidMount() {
		AGetQuotesNfo(this.getSchemeDetailsRes, this.isin);
	}

	render() {
		this.quoteComp = DeviceContext().isDesktop ? (
			<OpQuotesNfoDsk quoteData={this.state.quoteData} quoteDataExtra={this.state.quoteDataExtra} />
		) : DeviceContext().isTablet ? (
			<OpQuotesNfoTab quoteData={this.state.quoteData} quoteDataExtra={this.state.quoteDataExtra} />
		) : (
			<OpQuotesNfoMob quoteData={this.state.quoteData} quoteDataExtra={this.state.quoteDataExtra} />
		);
		return <OpLayout quoteComp={this.quoteComp} />;
	}
}

export default OpNfoContainer;
